import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Select } from '@backstage/core-components';
import useProjectPicker from './hooks';

export const ProjectPickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      dependentFields: {
        type: 'array',
        items: {
          type: 'string',
        },
      },
    },
  },
  returnValue: { type: 'object' },
};

export const ProjectPicker = (props: any) => {
  const { onChange, schema, required, formData, formContext } = props;
  const systemRef: string = formContext.formData?.system;

  const { options } = useProjectPicker(systemRef);

  return (
    <FormControl
      margin="normal"
      required={required}
      error={required && (!formData || formData.length === 0)}
    >
      <Select
        label={schema.title}
        placeholder="Select one or more project"
        items={options}
        multiple
        onChange={value => {
          if (Array.isArray(value)) {
            onChange(value);
          }
        }}
        selected={formData || []}
      />
      {schema.description && (
        <FormHelperText>{schema.description}</FormHelperText>
      )}
    </FormControl>
  );
};
